import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDataAlert = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.5 16.6667V15H12.5V16.6667H2.5ZM13.3333 10.8333C12.1806 10.8333 11.1979 10.4271 10.3854 9.61458C9.57292 8.80208 9.16667 7.81944 9.16667 6.66667C9.16667 5.51389 9.57292 4.53125 10.3854 3.71875C11.1979 2.90625 12.1806 2.5 13.3333 2.5C14.4861 2.5 15.4688 2.90625 16.2812 3.71875C17.0938 4.53125 17.5 5.51389 17.5 6.66667C17.5 7.81944 17.0938 8.80208 16.2812 9.61458C15.4688 10.4271 14.4861 10.8333 13.3333 10.8333ZM2.5 10V8.33333H7.75C7.84722 8.63889 7.95833 8.93056 8.08333 9.20833C8.20833 9.48611 8.36111 9.75 8.54167 10H2.5ZM2.5 13.3333V11.6667H10.3333C10.6528 11.8611 10.9931 12.0243 11.3542 12.1562C11.7153 12.2882 12.0972 12.3819 12.5 12.4375V13.3333H2.5ZM12.9167 7.5H13.75V4.16667H12.9167V7.5ZM13.3333 9.16667C13.4444 9.16667 13.5417 9.125 13.625 9.04167C13.7083 8.95833 13.75 8.86111 13.75 8.75C13.75 8.63889 13.7083 8.54167 13.625 8.45833C13.5417 8.375 13.4444 8.33333 13.3333 8.33333C13.2222 8.33333 13.125 8.375 13.0417 8.45833C12.9583 8.54167 12.9167 8.63889 12.9167 8.75C12.9167 8.86111 12.9583 8.95833 13.0417 9.04167C13.125 9.125 13.2222 9.16667 13.3333 9.16667Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDataAlert);
export default ForwardRef;
